import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

// Maps loads async, so the google.maps namespace is empty until these libraries resolve. App code
// touches google.maps at module load (e.g. BMCAOverlay extends OverlayView), so AppModule is imported
// only after they are in.
setOptions({ key: environment.googleMaps.apiKey, v: "weekly" });
Promise.all((["core", "maps", "marker", "geometry"] as const).map((lib) => importLibrary(lib)))
  .then(() => import("./app/app.module"))
  .then(({ AppModule }) => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch((err) => console.error(err));

// Localhost-only banner along the bottom of the screen showing which configuration this build
// loaded (dev vs prod Firebase project, emulator routing, prod mode). Deployed hosts never see it.
function showLocalConfigBanner() {
  if (!["localhost", "127.0.0.1"].includes(location.hostname)) return;

  const projectId = environment.firebase.projectId;
  const isProdBackend = projectId === "construction-eye-e250d";
  const banner = document.createElement("div");
  const emu = environment.emulator;
  // Emulator state is the thing worth noticing -> render just the ON/OFF as a bright-orange, bold
  // span when emulators are on. (projectId is a constant Firebase id, safe to interpolate.)
  banner.innerHTML =
    `${isProdBackend ? "PROD" : "DEV"} backend (${projectId}) · emulators ` +
    `<span style="color:${emu ? "#FF8800FF" : "#fff"};font-weight:800">${emu ? "ON" : "OFF"}</span>`;
  banner.style.cssText = [
    "position:fixed",
    "bottom:0",
    "left:50%",
    "transform:translateX(-50%)",
    "width:max-content",
    "max-width:90vw",
    "padding:0 20px",
    "white-space:nowrap",
    "border-radius:12px 12px 0 0",
    "z-index:2147483647",
    "pointer-events:none", // never intercept clicks meant for the app
    "text-align:center",
    "font:600 11px/1.8 monospace",
    "color:#fff",
    "text-shadow:0 1px 2px rgba(0,0,0,.4)",
    `background:${isProdBackend ? "rgba(178,34,34,.88)" : "rgba(34,197,94,.88)"}`,
  ].join(";");
  document.body.appendChild(banner);
}
showLocalConfigBanner();
